<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :searchModel="searchModel"
      @searchChange="handleSearchChange"
      :pages="pages"
      tableCardTitle="TNC DETAILS"
      @pageChange="params => _getTableData(params)"
    >
      <template v-slot:updateTime="{ tableRow }">
        {{ tableRow.row.updateTime || tableRow.row.createTime }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleView(tableRow.row)"
        />
      </template>
    </table-view>
    <table-view
      style="margin-top: 30px"
      :tableModel="tableModel"
      :tableData="tableData1"
      :pages="pages1"
      tableCardTitle="E-CREDIT History"
      @pageChange="params => _getHistoryData(params)"
    >
      <template v-slot:updateTime="{ tableRow }">
        {{ tableRow.row.updateTime || tableRow.row.createTime }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleView(tableRow.row)"
        />
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableData, getHistoryData } from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Tran#',
        type: 'input',
        key: 'bpmId',
        layout: {
          md: 24,
          lg: 10,
        },
      },
      {
        label: 'Code',
        type: 'select',
        key: 'conditionType',
        selectList: [],
      },
    ]
    const tableModel = [
      {
        width: 80,
        label: 'Action',
        slotName: 'action',
      },
      {
        width: 180,
        label: 'Tran#',
        prop: 'tran',
      },
      {
        width: 100,
        label: 'Active',
        prop: 'actionStr',
      },
      {
        width: 100,
        label: 'Code',
        prop: 'conditionTypeStr',
      },
      {
        minWidth: 180,
        label: 'Description',
        prop: 'desc',
      },
      {
        width: 100,
        label: 'Type',
        prop: 'tnCTypeStr',
      },
      {
        width: 130,
        label: 'Expiry Date',
        prop: 'tnCExpiryDate',
      },
      {
        width: 120,
        label: 'Status',
        prop: 'statusStr',
      },
      {
        width: 120,
        label: 'Modified By',
        prop: 'operator',
      },
      {
        width: 120,
        label: 'Last Modified',
        slotName: 'updateTime',
      },
    ]
    return {
      tableModel,
      tableData: [],
      tableData1: [],
      searchModel,
      pages: {},
      pages1: {},
    }
  },
  created() {
    this.getAllSelect()
  },
  mounted() {
    this.companyId = this.$route.params.customerId
    this.initTable()
  },
  methods: {
    async getAllSelect() {
      const res = await this._getSelectList({
        typeMark: 'ConditionType',
      })
      this.searchModel[1].selectList = res
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
      this._getHistoryData(params)
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData({
          ...params,
          companyId: this.companyId,
        })
        this.tableData = data
        this.tableData.map(item => {
          if (item.desc.includes('&gt;')) {
            item.desc = item.desc.replace(/&gt;/, '>')
          }
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    async _getHistoryData(params) {
      try {
        const { data, page } = await getHistoryData({
          ...params,
          companyId: this.companyId,
        })
        this.tableData1 = data
        this.tableData1.map(item => {
          if (item.desc.includes('&gt;')) {
            item.desc = item.desc.replace(/&gt;/, '>')
          }
        })
        this.pages1 = page
      } catch (err) {
        console.error(err)
      }
    },
    handleView({ id }) {
      this.$router.push({
        name: 'tnc-detail',
        params: {
          id,
        },
      })
    },
  },
}
</script>
